<template>
  <div class="auth-layout">
    <div class="auth-visual">
      <div class="visual-content">
        <div class="brand-logo" @click="handleLogoClick">
          <img :src="require('../assets/images/ipipbright.png')" alt="IpipBright logo" />
        </div>
        <div class="visual-text">
          <h1 class="gradient-text">{{ i18n[currentLanguage].brandSlogan }}</h1>
          <p>{{ i18n[currentLanguage].brandTagline }}</p>
        </div>

        <!-- 中间动态描述文案区块 -->
        <div class="dynamic-proxy-desc">
          <div class="desc-box">
            <a-icon type="api" class="desc-icon" />
            <div class="desc-text">
              <h3>{{ i18n[currentLanguage].dynamicTitle }}</h3>
              <p>{{ i18n[currentLanguage].dynamicContent }}</p>
            </div>
          </div>
          
          <div class="desc-box desc-box-alt">
            <a-icon type="node-index" class="desc-icon icon-alt" />
            <div class="desc-text">
              <h3>{{ i18n[currentLanguage].dynamicTitle2 }}</h3>
              <p>{{ i18n[currentLanguage].dynamicContent2 }}</p>
            </div>
          </div>
        </div>

        <div class="feature-list">
          <div class="f-item">
            <div class="f-icon"><a-icon type="safety-certificate" /></div>
            <div class="f-text">
              <h4>{{ i18n[currentLanguage].featureSecurity }}</h4>
              <p>{{ i18n[currentLanguage].featureSecurityDesc }}</p>
            </div>
          </div>
          <div class="f-item">
            <div class="f-icon"><a-icon type="swap" /></div>
            <div class="f-text">
              <h4>{{ i18n[currentLanguage].featureRotation }}</h4>
              <p>{{ i18n[currentLanguage].featureRotationDesc }}</p>
            </div>
          </div>
          <div class="f-item">
            <div class="f-icon"><a-icon type="global" /></div>
            <div class="f-text">
              <h4>{{ i18n[currentLanguage].featureRegions }}</h4>
              <p>{{ i18n[currentLanguage].featureRegionsDesc }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="glow-orb orb-1"></div>
      <div class="glow-orb orb-2"></div>
    </div>

    <div class="auth-form-panel">
      <div class="top-actions">
        <div class="lang-switch" @click="changeLanguage(currentLanguage === 'zh' ? 'en' : 'zh')">
          <a-icon type="global" /> {{ currentLanguage.toUpperCase() }}
        </div>
      </div>

      <div class="form-container">
        <div class="form-header">
          <h2>{{ i18n[currentLanguage].welcomeBack }}</h2>
          <p>{{ i18n[currentLanguage].pleaseLogin }}</p>
        </div>

        <a-form ref="form" :form="form" :rules="formRules" class="custom-form">
          <a-form-item prop="username">
            <a-input v-decorator="['username', { initialValue: '' }]" size="large" :placeholder="i18n[currentLanguage].username" class="modern-input">
              <a-icon slot="prefix" type="user" />
            </a-input>
          </a-form-item>

          <a-form-item prop="password">
            <a-input-password v-decorator="['password', { initialValue: '' }]" size="large" :placeholder="i18n[currentLanguage].password" class="modern-input">
              <a-icon slot="prefix" type="lock" />
            </a-input-password>
          </a-form-item>

          <a-form-item prop="goolecode">
            <a-input v-decorator="['goolecode', { initialValue: '' }]" size="large" placeholder="Google Auth Code (Optional)" class="modern-input">
              <a-icon slot="prefix" type="security-scan" />
            </a-input>
          </a-form-item>

          <a-form-item prop="userType" style="display: none;"><a-input v-decorator="['userType', { initialValue: 'ipipbright' }]"></a-input></a-form-item>
          <a-form-item prop="phone" style="display: none;"><a-input v-decorator="['phone', { initialValue: '' }]"></a-input></a-form-item>

          <div class="form-options">
            <a-checkbox v-decorator="['checked', { initialValue: false, valuePropName: 'checked' }]" class="custom-checkbox">
              {{ i18n[currentLanguage].rememberMe }}
            </a-checkbox>
          </div>

          <a-button type="primary" size="large" block @click="handleSubmit" class="modern-btn">
            {{ i18n[currentLanguage].login }} <a-icon type="arrow-right" />
          </a-button>

          <div class="auth-footer">
            <span>{{ i18n[currentLanguage].noAccount }}</span>
            <a href="/register">{{ i18n[currentLanguage].registerNow }}</a>
          </div>
        </a-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoginView',
  data() {
    return {
      form: this.$form.createForm(this),
      codeUrl: '',
      // 语言切换相关数据
      currentLanguage: 'en', // 默认中文
      languages: [
        { value: 'zh', label: '简体中文' },
        { value: 'en', label: 'English' }
      ],
      // 国际化文本
      i18n: {
        zh: {
          welcomeBack: '欢迎回来',
          pleaseLogin: '请使用您的账号登录',
          username: '账号',
          password: '密码',
          verificationCode: '验证码',
          rememberMe: '记住我',
          forgotPassword: '忘记密码？',
          login: '登录',
          noAccount: '还没有账号？',
          registerNow: '立即注册',
          loginSuccess: '登录成功',
          loginFailed: '登录失败',
          verificationCodeRequired: '验证码不能为空',
          requestFailed: '登录请求失败',
          getCodeFailed: '获取验证码失败',
          // 左侧品牌区域国际化 - 动态IP代理网站
          brandSlogan: '动态IP代理，全球网络加速',
          featureSecurity: '安全可靠',
          featureSecurityDesc: '企业级加密技术，保障数据安全',
          featureRotation: '智能轮换',
          featureRotationDesc: '自动IP轮换，防止被封锁',
          featureRegions: '全球覆盖',
          featureRegionsDesc: '覆盖200+国家和地区',
          featurePerformance: '高速稳定',
          featurePerformanceDesc: '99.9% uptime，低延迟连接',
          brandTagline: '选择ipipbright，畅享全球网络资源',
          statUsers: '活跃用户',
          statUptime: '服务可用性',
          statNodes: '优质IP节点',
          dynamicTitle: '高质量动态住宅代理',
          dynamicContent: '依托于业务大数据积累和IP库留存算法，能够为您提供指定应用场景下经过质量筛选的优质IP，支持灵活的定制和快速的网络环境切换。',
          dynamicTitle2: '千万级真实设备IP',
          dynamicContent2: '由全球各地的真实宽带设备组成，IP每日更新并智能轮换，极速连接保障您在数据采集和多账号业务上的高可用性。'
        },
        en: {
          welcomeBack: 'Welcome Back',
          pleaseLogin: 'Please login with your account',
          username: 'Username',
          password: 'Password',
          verificationCode: 'Verification Code',
          rememberMe: 'Remember Me',
          forgotPassword: 'Forgot Password?',
          login: 'Login',
          noAccount: 'Don\'t have an account?',
          registerNow: 'Register Now',
          loginSuccess: 'Login Success',
          loginFailed: 'Login Failed',
          verificationCodeRequired: 'Verification code is required',
          requestFailed: 'Login request failed',
          getCodeFailed: 'Failed to get verification code',
          // 左侧品牌区域国际化 - Dynamic IP Proxy Website
          brandSlogan: 'Dynamic IP Proxy, Global Network Acceleration',
          featureSecurity: 'Secure & Reliable',
          featureSecurityDesc: 'Enterprise-level encryption technology',
          featureRotation: 'Smart Rotation',
          featureRotationDesc: 'Automatic IP rotation to prevent blocking',
          featureRegions: 'Global Coverage',
          featureRegionsDesc: 'Covering 200+ countries and regions',
          featurePerformance: 'High Speed & Stable',
          featurePerformanceDesc: '99.9% uptime, low latency connection',
          brandTagline: 'Choose ipipbright, Enjoy Global Network Resources',
          statUsers: 'Active Users',
          statUptime: 'Service Availability',
          statNodes: 'Premium IP Nodes',
          dynamicTitle: 'High-Quality Dynamic Proxies',
          dynamicContent: 'Based on big data and IP retention algorithms, we provide quality-filtered IPs for specific scenarios, supporting flexible customization and fast network switching.',
          dynamicTitle2: 'Millions of Real Device IPs',
          dynamicContent2: 'Consists of real broadband devices worldwide. IPs are updated daily and intelligently rotated, ensuring high availability for data scraping and multi-account operations.'
        }
      },
      formRules: {
        username: [{ required: true, message: '账号必填', trigger: 'blur' }],
        password: [{ required: true, message: '密码必填', trigger: 'blur' }],
        code: [{ required: true, message: '验证码必填', trigger: 'blur' }]
      }
    };
  },
  mounted() {
    // this.getCodeNew();
  },
  methods: {
    // 处理logo点击事件
    handleLogoClick() {
      this.$router.push('/');
    },
    // 切换语言
    changeLanguage(language) {
      this.currentLanguage = language;
      // 更新表单规则的验证消息
      this.updateFormRules();
    },
    // 更新表单规则的验证消息
    updateFormRules() {
      this.formRules = {
        username: [{ required: true, message: this.i18n[this.currentLanguage].username + '必填', trigger: 'blur' }],
        password: [{ required: true, message: this.i18n[this.currentLanguage].password + '必填', trigger: 'blur' }],
        // code: [{ required: true, message: this.i18n[this.currentLanguage].verificationCode + '必填', trigger: 'blur' }]
      };
    },
    // 获取验证码
    getCodeNew() {
      // 假设request是全局可用的，或者需要通过import引入
      this.$request.get('/auth/captcha', { responseType: 'arraybuffer' })
        .then(res => {
          if (res.status === 200) {
            const base64 = btoa(new Uint8Array(res.data).reduce((data, byte) => data + String.fromCharCode(byte), ''));
            this.codeUrl = `data:image/png;base64,${base64}`;
            // 假设后端返回的uuid在响应头中
            // this.form.setFieldsValue({ uuid: res.headers.uuid });
          }
        })
        .catch(err => {
          console.error('获取验证码失败:', err);
          this.$message.error(this.i18n[this.currentLanguage].getCodeFailed);
        });
    },
    // 表单提交
    handleSubmit() {
      this.form.validateFields((err, values) => {
        if (!err) {
          // 假设request是全局可用的，或者需要通过import引入
          this.$request.post('/auth/login', values)
            .then(res => {
              if (res.data.code === 200) {
                // 登录成功处理
                localStorage.setItem('Token', res.data.data.token);
                localStorage.setItem('Authorization', res.data.data.token);
                localStorage.setItem('userName', values.username);
                localStorage.setItem('userId', res.data.data.uid);
                localStorage.setItem('subNumber', res.data.data.userInfo.subNumber);
                this.$message.success(this.i18n[this.currentLanguage].loginSuccess);
                this.$router.push('/dashboard/base');
              } else {
                // 登录失败处理
                if (res.data.msg === '验证码不能为空') {
                  this.$message.warning(this.i18n[this.currentLanguage].verificationCodeRequired);
                } else {
                  this.$message.warning(this.i18n[this.currentLanguage].loginFailed);
                }
                this.getCodeNew();
              }
            })
            .catch(err => {
              console.error('登录请求失败:', err);
              this.$message.error(this.i18n[this.currentLanguage].requestFailed);
            });
        }
      });
    }
  }
};
</script>

<style scoped>
* { box-sizing: border-box; }
.auth-layout {
  display: flex;
  min-height: 100vh;
  background: #2d2c28;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
}

/* Left Visual Panel */
.auth-visual {
  flex: 1;
  max-width: 45%;
  background: #1f1e1b;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding: 60px 50px;
  border-right: 1px solid rgba(255, 255, 255, 0.05);
}

.visual-content {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.brand-logo {
  cursor: pointer;
  margin-bottom: 60px;
}

.brand-logo img {
  height: 50px;
  transition: transform 0.3s ease;
}

.brand-logo:hover img {
  transform: scale(1.05);
}

.visual-text {
  margin-bottom: 60px;
}

.visual-text h1 {
  font-size: 3rem;
  font-weight: 800;
  line-height: 1.2;
  margin-bottom: 15px;
  color: #fff;
}

.gradient-text {
  background: linear-gradient(135deg, #1581c6 0%, #00ea90 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.visual-text p {
  font-size: 1.2rem;
  color: #aaa;
}

.feature-list {
  display: flex;
  flex-direction: column;
  gap: 30px;
  margin-top: auto;
}

.f-item {
  display: flex;
  align-items: flex-start;
  gap: 15px;
}

.f-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: rgba(21, 129, 198, 0.1);
  color: #1581c6;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  flex-shrink: 0;
}

.f-text h4 {
  color: #fff;
  font-size: 1.1rem;
  font-weight: 600;
  margin: 0 0 5px 0;
}

.f-text p {
  color: #888;
  font-size: 0.9rem;
  margin: 0;
  line-height: 1.4;
}

/* Dynamic Proxy Desc Section */
.dynamic-proxy-desc {
  margin: 40px 0;
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.desc-box {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 16px;
  padding: 24px;
  display: flex;
  align-items: flex-start;
  gap: 20px;
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.desc-box::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background: linear-gradient(to bottom, #1581c6, #00ea90);
}

.desc-box-alt::before {
  background: linear-gradient(to bottom, #00ea90, #1581c6);
}

.desc-box:hover {
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(21, 129, 198, 0.3);
  transform: translateY(-2px);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
}

.desc-icon {
  font-size: 32px;
  color: #00ea90;
  background: rgba(0, 234, 144, 0.1);
  padding: 12px;
  border-radius: 12px;
}

.icon-alt {
  color: #1581c6;
  background: rgba(21, 129, 198, 0.1);
}

.desc-text h3 {
  color: #fff;
  font-size: 1.2rem;
  font-weight: 700;
  margin: 0 0 8px 0;
}

.desc-text p {
  color: #aaa;
  font-size: 0.95rem;
  line-height: 1.6;
  margin: 0;
}

/* Decorative Orbs */
.glow-orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(80px);
  z-index: 1;
  opacity: 0.15;
}

.orb-1 {
  width: 400px;
  height: 400px;
  background: #1581c6;
  top: -100px;
  left: -100px;
  animation: float 10s infinite ease-in-out alternate;
}

.orb-2 {
  width: 500px;
  height: 500px;
  background: #00ea90;
  bottom: -150px;
  right: -100px;
  animation: float 12s infinite ease-in-out alternate-reverse;
}

@keyframes float {
  0% { transform: translate(0, 0); }
  100% { transform: translate(30px, 30px); }
}

/* Right Form Panel */
.auth-form-panel {
  flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;
  background: #2d2c28;
}

.top-actions {
  display: flex;
  justify-content: flex-end;
  padding: 30px 40px;
}

.lang-switch {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  color: #aaa;
  font-weight: 600;
  padding: 8px 16px;
  border-radius: 20px;
  background: #33342e;
  border: 1px solid rgba(255,255,255,0.05);
  transition: all 0.3s ease;
}

.lang-switch:hover {
  color: #fff;
  background: #1581c6;
  border-color: #1581c6;
}

.form-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px 40px;
}

.custom-form {
  width: 100%;
  max-width: 420px;
}

.form-header {
  width: 100%;
  max-width: 420px;
  margin-bottom: 40px;
}

.form-header h2 {
  font-size: 2.2rem;
  font-weight: 700;
  color: #fff;
  margin-bottom: 10px;
}

.form-header p {
  color: #888;
  font-size: 1.1rem;
  margin: 0;
}

/* Input Overrides */
:deep(.ant-input), :deep(.ant-input-password .ant-input) {
  height: 56px !important;
  background: #33342e !important;
  border: 1px solid rgba(255,255,255,0.08) !important;
  border-radius: 12px !important;
  color: #fff !important;
  font-size: 16px !important;
  padding-left: 45px !important;
  transition: all 0.3s ease !important;
  box-shadow: none !important;
}

:deep(.ant-input:focus), :deep(.ant-input:hover),
:deep(.ant-input-password:hover .ant-input),
:deep(.ant-input-password:focus-within .ant-input) {
  border-color: #1581c6 !important;
  background: #3a3935 !important;
}

:deep(.ant-input-prefix) {
  left: 15px !important;
  color: #888 !important;
  font-size: 18px !important;
}

:deep(.ant-input:focus ~ .ant-input-prefix) {
  color: #1581c6 !important;
}

:deep(.ant-input-password-icon) {
  color: #888 !important;
}

:deep(.ant-form-item) {
  margin-bottom: 24px;
}

.form-options {
  margin-bottom: 30px;
}

:deep(.ant-checkbox-wrapper) {
  color: #aaa;
}

:deep(.ant-checkbox-inner) {
  background-color: #33342e;
  border-color: rgba(255,255,255,0.2);
}

:deep(.ant-checkbox-checked .ant-checkbox-inner) {
  background-color: #1581c6;
  border-color: #1581c6;
}

.modern-btn {
  height: 56px;
  border-radius: 12px;
  font-size: 1.1rem;
  font-weight: 600;
  background: #1581c6;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: #fff;
  box-shadow: 0 4px 15px rgba(21,129,198,0.3);
  transition: all 0.3s ease;
}

.modern-btn:hover {
  background: #126ba5;
  color: #fff;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(21,129,198,0.4);
}

.auth-footer {
  margin-top: 30px;
  text-align: center;
  color: #888;
  font-size: 1rem;
}

.auth-footer a {
  color: #1581c6;
  font-weight: 600;
  margin-left: 5px;
  text-decoration: none;
  transition: color 0.3s;
}

.auth-footer a:hover {
  color: #00ea90;
}

/* Verification Code specific */
.code-wrapper {
  display: flex;
  gap: 15px;
}

.code-image-box {
  width: 140px;
  height: 56px;
  border-radius: 12px;
  background: #33342e;
  border: 1px solid rgba(255,255,255,0.08);
  overflow: hidden;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #888;
  transition: border-color 0.3s;
}

.code-image-box:hover {
  border-color: #1581c6;
}

.code-image-box img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

/* Responsive */
@media (max-width: 992px) {
  .auth-visual {
    display: none;
  }
  .auth-form-panel {
    background: #1f1e1b;
  }
}
</style>